import { Injectable } from "@angular/core";
import { HttpClientService } from "./http-client.service";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

@Injectable()
export class FollowUpService {
  constructor(private http: HttpClientService) {}

  public addFollowUp(followable_id: string | number, followable_type: string, exec_time: Date): Observable<any> {
    const params = {
      followable_id: followable_id,
      followable_type: followable_type,
      exec_time: exec_time,
    };
    return this.http.post("/api/follow_ups", params).pipe(tap((_) => console.log("FollowUpService.addFollowUp: Ok.")));
  }

  public searchFollowUp(followable_id: string | number, followable_type: string): Observable<any> {
    const params = {
      followable_id: followable_id,
      followable_type: followable_type,
    };
    return this.http
      .post("/api/follow_ups/search", params)
      .pipe(tap((_) => console.log("FollowUpService.searchFollowUp: Ok.")));
  }

  public deleteFollowUp(followable_id: string, followable_type: string): Observable<any> {
    const options = {
      params: {
        followable_id,
        followable_type,
      },
    };
    return this.http
      .delete("/api/follow_ups/destroy", options)
      .pipe(tap((_) => console.log("FollowUpService.deleteFollowUp: Ok.")));
  }
}
